import React, { useState, useEffect } from 'react'
import './PageHeader.scss'
import { CCol, CRow, CImage } from '@coreui/react-pro'
import Logo from '../../../assets/Logo.svg'
import AILogo from '../../../assets/BlueLogo.svg'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import SearchableProviderDropdown from '../SearchableDropdown/SearchableProviderDropdown'
import SettingsDropdown from './SettingsDropdown'
import { getDisplayDetails } from '../../../utils/sharedFunctions'
import { hasMedicalCoding } from '../shared/sharedProviderDisplayLogic'
import { resetCensusStore } from '../../../redux/census/censusSlice'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

const PageHeader = ({ setSelectedProvider }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const selectedProvider = useSelector((state) => state.user?.provider)
  const selectedPractice = useSelector((state) => state.user.practice) || {}
  const providerList = useSelector((state) => state.user.providerList) || {}

  const practiceProviders = providerList.filter(
    (prov) => prov.practice_id === (selectedPractice?.practice_id || selectedPractice?._id),
  )

  const dropDownOptions = practiceProviders
    .sort(function (a, b) {
      if (a?.last_name?.toLowerCase() < b?.last_name?.toLowerCase()) {
        return -1
      }
      if (a?.last_name?.toLowerCase() > b?.last_name?.toLowerCase()) {
        return 1
      }
      return 0
    })
    .map((x) => ({
      ...x,
      name: x?.last_name + ', ' + x?.first_name,
    }))

  const [selectedVal, setSelectedVal] = useState({
    ...practiceProviders[0],
    name: practiceProviders[0]
      ? practiceProviders[0]?.last_name + ', ' + practiceProviders[0]?.first_name
      : '',
  })

  const findSetSelected = (providerId) => {
    let temp = practiceProviders.filter((x) => x.provider_id === providerId)
    setSelectedVal({
      ...temp[0],
      name: temp[0] ? temp[0]?.last_name + ', ' + temp[0]?.first_name : '',
    })
  }

  useEffect(() => {
    findSetSelected(selectedProvider?._id)
  }, [selectedProvider])

  const { showLaneBanner, laneBannerTitle } = getDisplayDetails()

  return (
    <CRow
      className={`align-items-center justify-content-between census-page-title-container spacing-bottom ${laneBannerTitle}`}
    >
      <CCol xs={12} md={6} lg={4} className="census-page-title">
        <div
          onClick={(e) => {
            navigate('/selectPractice')
          }}
        >
          {selectedPractice?.organization_name}
        </div>
      </CCol>
      <CCol
        xs={12}
        md={6}
        lg={4}
        className="d-flex align-items-center justify-content-center census-page-logo"
      >
        <CImage
          className="notification-icon"
          src={getIsAi() ? AILogo : Logo}
          width={40}
          height={40}
        />
        <span> Claimocity </span>
        {showLaneBanner && <div>-{laneBannerTitle.toUpperCase()}</div>}
      </CCol>
      <CCol xs={12} md={6} lg={4} className="d-flex align-items-center justify-content-end">
        <div className="census-page-right-text">
          <div className="provider-dropdown-border">
            <SearchableProviderDropdown
              providerMedicalCoding={hasMedicalCoding({ provider: selectedProvider })}
              options={dropDownOptions}
              selectedVal={selectedVal}
              handleChange={async (newProviderInfo) => {
                findSetSelected(newProviderInfo?.provider_id)
                await dispatch(resetCensusStore())
                if (setSelectedProvider) {
                  setSelectedProvider(newProviderInfo)
                }
              }}
            />
          </div>
          <SettingsDropdown />
        </div>
      </CCol>
    </CRow>
  )
}

export default PageHeader
